import {getNewDate} from './dateHelper'

function isBoletoVencido(dataVencimento) {
  return new Date().getTime() > getNewDate(dataVencimento).getTime();
}

export {
  isBoletoVencido  
}